export default __webpack_public_path__ + "static/media/animalfour.b49e5d01.png";